import { render, staticRenderFns } from "./SettingsTypeModal.vue?vue&type=template&id=776a1529&scoped=true&"
import script from "./SettingsTypeModal.vue?vue&type=script&lang=js&"
export * from "./SettingsTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTypeModal.vue?vue&type=style&index=0&id=776a1529&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776a1529",
  null
  
)

export default component.exports